// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-image-message-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  min-height: 110px;
  background: rgba(238, 238, 238, 0.6);
  border-radius: 12px;
  overflow: hidden;
}
.chat-image-message-item .chat-image-preview {
  max-width: 100%;
  max-height: 320px;
}
.chat-image-message-item .chat-image-empty svg {
  width: 64px;
  height: 64px;
}
.chat-image-message-item .chat-image-loading {
  border-radius: 12px;
  content: "";
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-color: rgba(135, 135, 135, 0.5);
  position: absolute;
  top: 0;
  left: 0;
}
.chat-image-message-item .chat-image-loading svg {
  width: 48px;
  height: 48px;
}
.chat-image-message-item .chat-image-loading .ant-btn {
  border: 0;
}
.chat-image-message-item .chat-image-loading .ant-btn svg {
  width: 12px;
  height: 12px;
}
.chat-image-message-item .chat-image-error {
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
  border-radius: 50%;
}
.chat-image-message-item .chat-image-error svg {
  width: 16px;
  height: 16px;
}
.chat-image-message-item .chat-image-error .chat-image-tip {
  visibility: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
  color: #E02828;
}
.chat-image-message-item:hover .chat-image-tip {
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/feature/chat/component/chat-image-message-item.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;AACF;AAAE;EACE,eAAA;EACA,iBAAA;AAEJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AAEE;EACE,mBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAAJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AACI;EACE,SAAA;AACN;AAAM;EACE,WAAA;EACA,YAAA;AAER;AAEE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,kBAAA;AAAJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AACI;EACE,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AACN;AAGI;EACE,mBAAA;AADN","sourcesContent":[".chat-image-message-item {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 150px;\n  min-height: 110px;\n  background: rgba(238, 238, 238, 0.6);\n  border-radius: 12px;\n  overflow: hidden;\n  .chat-image-preview {\n    max-width: 100%;\n    max-height: 320px;\n  }\n  .chat-image-empty {\n    svg{\n      width: 64px;\n      height: 64px;\n    }\n  }\n  .chat-image-loading {\n    border-radius: 12px;\n    content: '';\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(135, 135, 135, 0.5);\n    position: absolute;\n    top: 0;\n    left: 0;\n    svg {\n      width: 48px;\n      height: 48px;\n    }\n    .ant-btn {\n      border: 0;\n      svg {\n        width: 12px;\n        height: 12px;\n      }\n    }\n  }\n  .chat-image-error {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    transform: translate(50%, 50%);\n    border-radius: 50%;\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n    .chat-image-tip {\n      visibility: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow-x: hidden;\n      color: #E02828;\n    }\n  }\n  &:hover{\n    .chat-image-tip {\n      visibility: visible;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
